import React from 'react';
import {
  formatLastUpdate,
  getOnlineStatus,
  STATUS_META,
} from '../../utils/locationUtils';
import LocationName from './LocationName';

const Row = ({ label, value }) => {
  if (!value) return null;
  return (
    <div className="flex justify-between gap-3 text-xs py-0.5">
      <span className="text-slate-500 shrink-0">{label}</span>
      <span className="text-slate-800 font-medium text-right break-all">{value}</span>
    </div>
  );
};

export function EmployeeMarkerDetails({ employee, compact = false }) {
  if (!employee) return null;

  const meta = STATUS_META[employee.status] || STATUS_META.offline;
  const online = getOnlineStatus(employee);

  return (
    <div className={compact ? 'min-w-[200px]' : 'min-w-[240px]'}>
      <div className="flex items-start justify-between gap-2 mb-2">
        <div>
          <p className="font-bold text-[#1a365d] text-sm">{employee.name}</p>
          <p className="text-xs text-slate-600">{employee.position || 'Employee'}</p>
        </div>
        <span className={`shrink-0 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${online.badge}`}>
          {online.label}
        </span>
      </div>

      <div className="space-y-1 border-t border-slate-100 pt-2 mt-2">
        <Row label="Employee ID" value={employee.employeeId} />
        <Row label="Department" value={employee.department} />
        <Row label="Email" value={employee.email} />
        <Row label="Phone" value={employee.phone} />
        <Row label="Company" value={employee.company} />
      </div>

      <div className="space-y-1 border-t border-slate-100 pt-2 mt-2">
        <div className="flex justify-between gap-3 text-xs py-0.5">
          <span className="text-slate-500">Activity</span>
          <span className={`px-1.5 py-0.5 rounded-full text-[10px] font-semibold ${meta.badge}`}>
            {meta.label}
          </span>
        </div>
        <div className="flex justify-between gap-3 text-xs py-0.5 items-start">
          <span className="text-slate-500 shrink-0">Exact location</span>
          <LocationName
            lat={employee.latitude}
            lng={employee.longitude}
            approximate={employee.isApproximateLocation}
            accuracy={employee.accuracy}
            className="text-slate-800 font-medium text-right max-w-[220px]"
            showCoords
          />
        </div>
        <Row
          label="Source"
          value={
            employee.isLive
              ? 'Live GPS'
              : employee.locationSource === 'last-known'
                ? 'Last known GPS'
                : employee.locationSource === 'attendance'
                  ? 'Check-in GPS'
                  : employee.hasLocation
                    ? 'GPS'
                    : null
          }
        />
        <Row label="Last update" value={formatLastUpdate(employee.lastUpdate)} />
        {employee.officeName ? <Row label="Office" value={employee.officeName} /> : null}
        {employee.trail?.length > 1 ? (
          <Row label="Trail today" value={`${employee.trail.length} GPS points`} />
        ) : null}
      </div>
    </div>
  );
}

export default EmployeeMarkerDetails;
